import { SurveyResponseStatus } from '@/types';
import { Typography } from '@/ui';

import Info from './Info';

import type { SurveyResponse } from '@/types';
import type { FC } from 'react';

interface HeaderProps {
  responses: SurveyResponse[];
  respondedCount?: number;
  show: boolean;
  toggleShow: () => void;
}

const Header: FC<HeaderProps> = ({
  responses,
  respondedCount,
  show,
  toggleShow,
}) => {
  const rolesText = show ? 'Showing names and roles' : 'Names and roles hidden';
  const rolesButton = !show ? 'Show' : 'Hide';

  const completed =
    respondedCount ??
    responses.filter(({ status }) => status === SurveyResponseStatus.COMPLETED)
      .length;

  const total = responses.length;
  const canShowTotal = total > 0 && completed <= total;
  const respondedText = canShowTotal
    ? `${completed} out of ${total} responded`
    : `${completed} responded`;

  return (
    <div className="pl-4 pt-2">
      <Typography className="text-cement-600" variant="body1">
        {respondedText}
      </Typography>
      <div className="body-sm flex text-cement-400">
        <Typography className="my-auto">{rolesText}&nbsp;</Typography>
        <Typography
          className="my-auto cursor-pointer underline"
          onClick={toggleShow}
        >
          {rolesButton}
        </Typography>
        <Info />
      </div>
    </div>
  );
};

export default Header;
